import React from "react";

const InvitePeopleIcon = () => {
  return (
    <svg
      width="34"
      height="23"
      viewBox="0 0 34 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="23.2627"
        cy="6.63572"
        r="4.74936"
        stroke="#004352"
        strokeWidth="1.77272"
      />
      <path
        d="M14 20.5007C14 12.1176 32.1276 12.4575 32.1276 20.5007C32.1276 21.4996 14 21.5 14 20.5007Z"
        stroke="#004352"
        strokeWidth="1.77272"
      />
      <path
        d="M5.88867 10.1357H9.45703V11.6738H5.88867V15.7168H4.25391V11.6738H0.685547V10.1357H4.25391V6.40039H5.88867V10.1357Z"
        fill="#004352"
      />
    </svg>
  );
};

export default InvitePeopleIcon;
